import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import TrustpilotStars from "../../Components/TrustpilotStars";
import GoogleRatingStars from "../../Components/GoogleRatingStars";
import PlanList from "../../Components/PlanList";
import MinPlanPrice from "../../Components/MinPlanPrice";
import sal from "sal.js";
import { Helmet } from "@dr.pogodin/react-helmet";
import { ScrollToPlans } from "../../utils/ScrollToPlan";
import CategoryPriceBox  from "../../Components/CatgeoryPriceBox";
import CouponScrollBar from "../../Components/CouponScrollBar";

export default function LinuxHosting() {
  const [applyPaddingClass, setApplyPaddingClass] = useState(false);
  useEffect(() => {
    document.title = "Best Linux Hosting Services for Speed, Security & Support";
          sal();
      }, []);
      const handlePlanClick = () => {
    ScrollToPlans(".price-plan-section");
    };
  return (
    <>
    <Helmet>
        <title>Best Linux Hosting Services for Speed, Security & Support</title>
        <meta name="description" content="Get fast and secure Linux hosting at unbeatable prices. Enjoy free SSL, weekly backups, SSD storage, and easy WordPress setup. Start today." />
        <meta name="keywords" content="Linux Server Hosting, Linux Web Hosting, Best Linux Hosting, Linux Hosting Services, Linux Web Server Hosting, Server Linux Hosting, Best Linux Web Hosting, Best Linux For Web Hosting, Best Linux Web Hosting Services, Best Linux Website Hosting, Linux For Web Hosting, Linux Web Hosting Services, Linux Hosting" />
        <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/linux-hosting`} />
        <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/linux-hosting`} />
        <meta property="og:title" content="Discover the Best Linux Hosting Option for Your Business" />
        <meta property="og:description" content="Check out the best Linux hosting service that provides scalability & flexibility for your requirements. Get high security & 24/7 customer support under budget." />
    </Helmet>
    <section className="banner-bg bg-dark server-banner">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-7 col-xl-6">
                    <span className="fs-18 fw-semibold text-primary mb-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        Hosting: Powered by Linux
                    </span>
                    <h1 className="text-white mb-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        Linux Hosting Made Simple & Completely Yours
                    </h1>
                    <p className="mb-8 text-white max-text-72 text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        Are you tired of stringent hosting limits? Experience the complete freedom of Linux Hosting-where security, reliability, and cost-effectiveness converge. Customize your space, accelerate your business growth, and never look back.
                    </p>
                    <div className="d-flex align-items-center gap-5 flex-wrap sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <button onClick={handlePlanClick} className="btn btn-primary btn-arrow btn-arrow btn-arrow-md btn-lg fs-14 fw-medium rounded btn-height">
                            <span className="btn-arrow__text">
                                Get Started
                                <span className="btn-arrow__icon">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                            </span>
                        </button>
                        <MinPlanPrice category="linux-hosting" />
                    </div>
                    <span className="d-block fs-14 text-white text-opacity-75 mt-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Get 100% Refund Within 30 Days* <sup><small className="text-opacity-50 tnc-text">T&Cs</small></sup></span>
                </div>
                <div className="col-lg-5 col-xl-6 text-lg-end ipad-mt">
                    <img src="/images/linux-hosting-made.webp" alt="image" className="img-fluid sal-animate full-width-img" data-sal="fade" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine"/>
                </div>
            </div>
        </div>
    </section>

      <section className="domain-container position-relative z-1 overflow-hidden">
              <div className="container">
                  <div className="row justify-content-center">
                      <div className="col-xl-10">
                          <div className="card cta-wrapper-one rounded-4 domain-container-inner">
                              <div className="card-body pt-60 pb-60">
                                  <div className="row justify-content-center">
                                    <div className="col-md-11 col-lg-10 col-xl-10">
                                        <div className="text-center">
                                          <span className="section-title style-bg fadeInUp mb-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Grow With Linux</span>
                                            <h4 className="mb-4">
                                                Linux Shared Hosting Plans: Your Launchpad For Growth&nbsp;
                                            </h4>
                                            <p className="mb-6">
                                              Explore Linux shared hosting that genuinely understands your demands cost-effective, scalable, and engineered to grow with your business. No complexity, just effortless support, and seamless performance.
                                            </p>
                                            <Link to="tel:7737300013" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded me-sm-2 btn-height">
                                                <span className="d-inline-block me-1 flex-shrink-0">
                                                    <i className="las la-comments"></i>
                                                </span>
                                                <span className="btn-arrow__text">
                                                    +91-7737300013
                                                    <span className="btn-arrow__icon">
                                                        <i className="fa-solid fa-arrow-right"></i>
                                                    </span>
                                                </span>
                                            </Link>
                                            <Link to="#" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded ms-sm-2 mt-sm-0 mt-4 open-live-chat btn-height">
                                                <span className="d-inline-block me-1 flex-shrink-0">
                                                    <i className="las la-comments"></i>
                                                </span>
                                                <span className="btn-arrow__text">
                                                    Talk to an Expert
                                                    <span className="btn-arrow__icon">
                                                        <i className="fa-solid fa-arrow-right"></i>
                                                    </span>
                                                </span>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
      </section>

      <div className="pt-100 pb-100 linux-hosting-points-section">
        <div className="pb-60">
            <div className="container">
                <div className="row g-4 align-items-center justify-content-xl-between">
                    <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded">
                            <span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>Budget-Friendly Solutions
                        </small>
                        <h2 className="mb-4">
                            Budget Meets Brilliance: Secure Linux Shared Hosting
                        </h2>
                        <p className="max-text-56 mb-0 fw-semibold">
                            With the help of Linux shared hosting, it’s no longer any dream. Avoid the struggle of clumsy setups and continuous errors. Get a Linux hosting experience where everything just simply clicks-seamless, and engineered for business success.
                        </p>
                    </div>
                    <div className="col-lg-6 col-xl-5 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                        <div className="card">
                            <div className="card-body cloud-hosting-vid-card">
                                <div className="features-video position-relative z-1">
                                    <img src="/images/infi-common-video-yt-thumb.jpg" alt="image" className="img-fluid w-100"/>
                                    <Link to="https://youtu.be/x10KM9gI110?si=kVgGnbSAsh-zfKn7" target="_blank" className="btn gradient-bg w-15 h-15 d-grid place-content-center rounded-circle position-absolute top-50 start-50 translate-middle fs-24 text-white popup-init">
                                        <i className="fa-solid fa-play"></i>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="container">
            <div className="row g-4">
                <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="card border-0 shadow-sm rounded-4 h-100">
                        <div className="card-body p-md-6 p-xl-8">
                            <div className="mb-8">
                                <img src="/images/scalability-that-evolves.webp" alt="image" className="img-fluid"/>
                            </div>
                            <h6 className="mb-4">
                                Scalability That Evolves & Thrives
                            </h6>
                            <p className="mb-0">
                                Say bye-bye to all limits and hello to hosting comfort. With the help of Linux Server Hosting, your site constantly evolves with zero downtime. Ranging from humble starting to flourishing peaks, our plans scale when your business grows.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="card border-0 shadow-sm rounded-4 h-100">
                        <div className="card-body p-md-6 p-xl-8">
                            <div className="mb-8">
                                <img src="/images/automatic-backups.webp" alt="image" className="img-fluid"/>
                            </div>
                            <h6 className="mb-4">
                                Automatic Backups
                            </h6>
                            <p className="mb-0">
                                Are you stressed about losing sensitive data? Our managed Linux hosting offers secure, automatic backups-so your site stays safe even at the time of disaster. No stress, no manual steps-just relaxation, knowing your files are always one step ahead.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                    <div className="card border-0 shadow-sm rounded-4 h-100">
                        <div className="card-body p-md-6 p-xl-8">
                            <div className="mb-8">
                                <img src="/images/secure-stress-free.webp" alt="image" className="img-fluid"/>
                            </div>
                            <h6 className="mb-4">
                                Secure, Stress-Free Linux Hosting
                            </h6>
                            <p className="mb-0">
                                Your site's security shouldn't keep you up at night. With the help of our Managed Linux Hosting, we constantly observe your server, check for malware or any other anomalous activity, and take quick action-even before you detect it.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="card border-0 shadow-sm rounded-4 h-100">
                        <div className="card-body p-md-6 p-xl-8">
                            <div className="mb-8">
                                <img src="/images/limitless-assets.webp" alt="image" className="img-fluid"/>
                            </div>
                            <h6 className="mb-4">
                                Limitless Assets, Scale Smoothly
                            </h6>
                            <p className="mb-0">
                                Are you tired of wasted space and constant lagging? With the help of Linux Dedicated Server Hosting, each resource gets its right place. No padding, just refined performance that lets your business grow without any compromise.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="card border-0 shadow-sm rounded-4 h-100">
                        <div className="card-body p-md-6 p-xl-8">
                            <div className="mb-8">
                                <img src="/images/free-ssl-certificate.webp" alt="image" className="img-fluid"/>
                            </div>
                            <h6 className="mb-4">
                                Free SSL Certificate
                            </h6>
                            <p className="mb-0">
                                Your website's security shouldn't cost you an extra penny. That's why all our Linux hosting solutions come with a free SSL certificate always keeping your data highly secure and your site visitors confident from the very first click.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                    <div className="card border-0 shadow-sm rounded-4 h-100">
                        <div className="card-body p-md-6 p-xl-8">
                            <div className="mb-8">
                                <img src="/images/one-click-installation.webp" alt="image" className="img-fluid"/>
                            </div>
                            <h6 className="mb-4">
                                One Click Installation
                            </h6>
                            <p className="mb-0">
                                No more clunky setups. With the help of our Linux Hosting, launching your site is as easy as a single click. Even if it's custom scripts or WordPress, installation is smooth and our expert support is always here when you want a hand.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>

      <section className="price-plan-section pt-100 pb-100">
          <CouponScrollBar setPaddingClass={setApplyPaddingClass} />
          <div className={`pb-40 ${applyPaddingClass ? "plan-extra-top-padding" : ""}`}>
              <div className="container">
                  <div className="row justify-content-center">
                      <div className="col-xl-8">
                          <div className="text-center">
                              <span className="section-title-dark style-bg fadeInUp">Our Plans</span>
                              <h2 className="theme-title-text-white" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine"> Your Demands - Our Solutions</h2>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        <PlanList category={'linux-hosting'}/>
      </section>

      <section className="bg-light-13 pt-100 pb-100">
        <div className="container">
            <div className="row">
                <div className="col-xl-9">
                    <small className="d-inline-block mb-2 fw-bold bg-primary-subtle text-primary-emphasis border border-primary-subtle px-3 py-1 rounded"><span className="d-inline-block w-2 h-2 bg-primary rounded-circle me-1"></span>Flexible Linux Solutions</small>
                    <h2 className="mb-0">Managed Linux Hosting: For People with Genuine Demands.</h2>
                </div>
            </div>
            <div className="mt-12">
                <div className="row g-4">
                    <div className="col-lg-4">
                        <div className="bg-primary p-5 rounded-3 mb-8">
                            <div className="bg-white p-4 rounded-3 mb-8">
                                <div className="text-center">
                                    <img src="/images/support.png" alt="Image" className="img-fluid mb-3"/>
                                    <h6 className="mb-2">Infinitive Support</h6>
                                    <p className="mb-4">Technical Support specialists</p>
                                    <div className="style_15 d-inline-flex align-items-center justify-content-center gap-2">
                                        <Link to="https://wa.me/+917742553946?text=I recently check out your official website and was impressed by your web hosting solutions. I’m ready to buy a web hosting plan that matches my requirements. Could you please help me through the process?" target="_blank" rel="noopener noreferrer" className="social-icon w-9 h-9 d-inline-flex align-items-center justify-content-center rounded-circle border border-dark border-opacity-10">
                                            <span className="text-body"><i className="fa-brands fa-whatsapp"></i></span>
                                        </Link>
                                        <Link to="https://www.instagram.com/infinitive_host?igsh=MThiMHNqcXlia2hsYQ%3D%3D&utm_source=qr" target="_blank" className="social-icon w-9 h-9 d-inline-flex align-items-center justify-content-center rounded-circle border border-dark border-opacity-10">
                                            <span className="text-body"><i className="fa-brands fa-instagram"></i></span>
                                        </Link>
                                        <Link to="https://www.linkedin.com/company/infinitivehost/" target="_blank" className="social-icon w-9 h-9 d-inline-flex align-items-center justify-content-center rounded-circle border border-dark border-opacity-10">
                                            <span className="text-body"><i className="fa-brands fa-linkedin-in"></i></span>
                                        </Link>
                                        <Link to="https://www.facebook.com/InfinitiveHost-435551663445191" target="_blank" className="social-icon w-9 h-9 d-inline-flex align-items-center justify-content-center rounded-circle border border-dark border-opacity-10">
                                            <span className="text-body"><i className="fa-brands fa-facebook-f"></i></span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <h6 className="text-white mb-5">Industry Leading Live Support, 24/7</h6>
                            <p className="text-white mb-8">We always put our customers first, from product planning to every single chat and ticket. With 9 years of experience, we’ll make sure you have an exceptional experience.</p>
                            <Link to="#" className="btn btn-light border-0 btn-arrow btn-arrow-md fs-14 fw-medium rounded open-live-chat btn-height">
                                <span className="btn-arrow__text">
                                    LiveChat
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </Link>
                        </div>
                        <img src="/images/live_chat_img.webp" alt="Image" className="img-fluid"/>
                    </div>
                    <div className="col-lg-8">
                        <div className="row g-4">
                            <div className="col-md-6">
                                <div className="card h-100">
                                  <div className="card-body p-xl-6">
                                    <img src="/images/unshakable-server-performance.webp" alt="Image" className="img-fluid mb-5"/>
                                    <h6 className="mb-5">Unshakable Server Performance</h6>
                                    <p className="mb-0">With the help of our Linux Hosting, handling your site becomes second nature. Backed by our powerful infrastructure, we help you skip all the technical stress and emphasize what matters.</p>
                                  </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="card h-100">
                                  <div className="card-body p-xl-6">
                                    <img src="/images/speed-meets-exceptional-purity.webp" alt="Image" className="img-fluid mb-5"/>
                                    <h6 className="mb-5">Speed Meets Exceptional Purity</h6>
                                    <p className="mb-0">Worried about unscalable web hosting? With our Linux cPanel hosting, you experience top-notch performance, thanks to built-in server caching. Our solutions scale with your business needs.</p>
                                  </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="card h-100">
                                  <div className="card-body p-xl-6">
                                    <img src="/images/shielded-by-top-notch-security.webp" alt="Image" className="img-fluid mb-5"/>
                                    <h6 className="mb-5">Shielded by Top-Notch Security</h6>
                                    <p className="mb-0">Tired of unexpected security breaches? Rest without stress. Our every Linux hosting plan has cPGuard antivirus & CSF firewalls-built-in layers of security that always keep your site protected.</p>
                                  </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="card h-100">
                                  <div className="card-body p-xl-6">
                                    <img src="/images/smooth-migration-no-headaches.webp" alt="Image" className="img-fluid mb-5"/>
                                    <h6 className="mb-5">Smooth Migration, No Headaches</h6>
                                    <p className="mb-0">With our best Linux hosting solutions, migration is smooth. We guarantee compatibility with your previous apps and manage everything-ranging from uploading to installing your databases.</p>
                                  </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                               <div className="card h-100">
                                  <div className="card-body p-xl-6">
                                    <img src="/images/powered-by-modern-technology.webp" alt="Image" className="img-fluid mb-5"/>
                                    <h6 className="mb-5">Powered by Modern Technology</h6>
                                    <p className="mb-0">We don't just host your site-we pioneer. As one of the best Linux hosting providers, we use next-gen technologies to improve performance. Get a smarter way that scales as per your demands.</p>
                                  </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="card h-100">
                                  <div className="card-body p-xl-6">
                                    <img src="/images/hosting-made-easy.webp" alt="Image" className="img-fluid mb-5"/>
                                    <h6 className="mb-5">Hosting Made Easy</h6>
                                    <p className="mb-0">Even if you're an experienced one, our best Linux hosting services are engineered to be intuitive. With single-click installations for various apps, you can easily launch your site in very little time.</p>
                                  </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </section>

        <div className="pt-100 pb-100">
        <div className="pb-40">
            <div className="container">
                <div className="row">
                    <div className="col-md-10 col-lg-8 col-xl-7 sal-animate m-auto text-center" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                      <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded m-auto"><span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>More Plans</small>
                        <h2 className="mb-0 text-center">
                            Still Opting? Surf Through Our Other Solutions!
                        </h2>
                    </div>
                </div>
            </div>
        </div>
        <div className="container">
            <div className="row g-4">
                <div className="col-md-6 col-lg-4 col-xl-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="price-card-item-one position-relative bg-white px-7 py-9 text-center rounded h-100">
                        <div className="mb-2">
                            <img src="/images/cloud-hosting.webp" alt="image" className="img-fluid"/>
                        </div>
                        <h6>
                            Cloud Hosting
                        </h6>
                        <CategoryPriceBox category="cloud-hosting" />
                        <Link to="/cloud-hosting" className="btn btn-dark btn-arrow btn-lg fs-14 fw-medium rounded transition mt-6 btn-height">
                            <span className="btn-arrow__text">
                                Explore Plan
                                <span className="btn-arrow__icon">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                            </span>
                        </Link>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="price-card-item-one position-relative bg-white px-7 py-9 text-center rounded h-100">
                        <div className="mb-2">
                            <img src="/images/linux-reseller.webp" alt="image" className="img-fluid"/>
                        </div>
                        <h6>
                            Linux Reseller
                        </h6>
                        <CategoryPriceBox category="linux-reseller-hosting" />
                        <Link to="/linux-reseller-hosting" className="btn btn-dark btn-arrow btn-lg fs-14 fw-medium rounded transition mt-6 btn-height">
                            <span className="btn-arrow__text">
                                Explore Plan
                                <span className="btn-arrow__icon">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                            </span>
                        </Link>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                    <div className="price-card-item-one position-relative bg-white px-7 py-9 text-center rounded h-100">
                        <div className="mb-2">
                            <img src="/images/linux-vps.webp" alt="image" className="img-fluid"/>
                        </div>
                        <h6>
                            Linux VPS
                        </h6>
                        <CategoryPriceBox category="managed-linux-vps" />
                        <Link to="/managed-linux-vps" className="btn btn-dark btn-arrow btn-lg fs-14 fw-medium rounded transition mt-6 btn-height">
                            <span className="btn-arrow__text">
                                Explore Plan
                                <span className="btn-arrow__icon">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                            </span>
                        </Link>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="600" data-sal-easing="ease-in-out-sine">
                    <div className="price-card-item-one position-relative bg-white px-7 py-9 text-center rounded h-100">
                        <div className="mb-2">
                            <img src="/images/windows-vps.webp" alt="image" className="img-fluid"/>
                        </div>
                        <h6>
                            Windows Cloud VPS
                        </h6>
                        <CategoryPriceBox category="windows-cloud-vps" />
                        <Link to="/windows-cloud-vps" className="btn btn-dark btn-arrow btn-lg fs-14 fw-medium rounded transition mt-6 btn-height">
                            <span className="btn-arrow__text">
                                Explore Plan
                                <span className="btn-arrow__icon">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                            </span>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </>
  );
}
